module.exports = __webpack_public_path__ + "static/media/VladaSlide.69764386.jpg";